import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TmTransporterService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/tm-transporters', params);
    }

    store(body: any) {
        return super.post(`/tm-transporters`, body);
    }

    edit(tmTransporterId: number) {
        return super.get(`/tm-transporters/${tmTransporterId}/edit`);
    }

    update(tmTransporterId: number, body: any) {
        return super.put(`/tm-transporters/${tmTransporterId}`, body);
    }

    destroy(tmTransporterId: number) {
        return super.delete(`/tm-transporters/${tmTransporterId}`);
    }

    select(params: any = {}) {
        return super.get(`/tm-transporters/select`, params);
    }
}
